import { render, staticRenderFns } from "./CafeteriaSelector.vue?vue&type=template&id=d8b65452"
import script from "./CafeteriaSelector.vue?vue&type=script&lang=js"
export * from "./CafeteriaSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports